export const translations = {
  tr: {
    // Common
    save: "Kaydet",
    cancel: "İptal",
    close: "Kapat",
    submit: "Gönder",
    loading: "Yükleniyor...",
    search: "Ara",
    
    // Auth
    login: "Giriş Yap",
    register: "Kayıt Ol",
    email: "E-posta",
    password: "Şifre",
    name: "Ad Soyad",
    forgotPassword: "Şifremi Unuttum",
    
    // Menu
    notifications: "Bildirimler",
    support: "Destek",
    personalization: "Kişiselleştirme",
    settings: "Ayarlar",
    parentPanel: "Ebeveyn Panel",
    logout: "Oturumu Kapat",
    back: "Geri Dön",
    
    // Support
    supportCenter: "Destek Merkezi",
    newTicket: "Yeni Talep",
    myTickets: "Taleplerim",
    category: "Kategori",
    subject: "Konu",
    message: "Mesajınız",
    sendTicket: "Destek Talebi Gönder",
    noTickets: "Henüz destek talebi oluşturmadınız",
    ticketCreated: "İlk Talebinizi Oluşturun",
    supportTeamResponse: "Destek ekibimiz genellikle 24 saat içinde geri dönüş yapar.",
    
    // Categories
    general: "Genel",
    technical: "Teknik Sorun",
    billing: "Ödeme/Abonelik",
    feedback: "Geri Bildirim",
    
    // Status
    open: "Açık",
    inProgress: "İşlemde",
    closed: "Çözüldü",
    resolved: "Çözüldü",
    
    // Notifications
    noNotifications: "Henüz bildiriminiz yok",
    markAllRead: "Tümünü Okundu İşaretle",
    supportResolved: "Destek Talebiniz Çözümlendi",
    
    // Personalization
    theme: "Tema",
    dark: "Koyu",
    light: "Açık",
    language: "Dil",
    languageNote: "Dil ayarları kaydedildi",
    
    // Placeholders
    enterEmail: "ornek@email.com",
    enterPassword: "********",
    enterSubject: "Destek talebinizin konusu",
    enterMessage: "Lütfen sorununuzu veya geri bildiriminizi detaylı bir şekilde açıklayın...",
    
    // Parent Dashboard
    parentDashboard: "Ebeveyn Paneli",
    myChildren: "Çocuklarım",
    addChild: "Çocuk Ekle",
    linkExistingChild: "Mevcut Hesap Bağla",
    createNewChild: "Yeni Hesap Oluştur",
    overview: "Genel Bakış",
    riskHistory: "Risk Geçmişi",
    chatHistory: "Sohbet Geçmişi",
    notificationSettings: "Bildirim Ayarları",
    childName: "Çocuk Adı",
    childEmail: "Çocuk E-postası",
    age: "Yaş",
    grade: "Sınıf",
    linkRequest: "Bağlantı İsteği Gönder",
    createAccount: "Hesap Oluştur",
    noChildren: "Henüz bağlı çocuk hesabınız yok",
    selectChild: "Bir çocuk seçin",
    totalThreats: "Toplam Tehdit",
    criticalThreats: "Kritik Tehdit",
    riskScore: "Risk Skoru",
    lastActivity: "Son Aktivite",
    noRiskHistory: "Risk geçmişi bulunamadı",
    noChatHistory: "Sohbet geçmişi bulunamadı",
    emailNotifications: "E-posta Bildirimleri",
    phoneNotifications: "Telefon Bildirimleri",
    
    // Admin Dashboard
    adminDashboard: "Admin Paneli",
    users: "Kullanıcılar",
    sessions: "Oturumlar",
    messages: "Mesajlar",
    totalUsers: "Toplam Kullanıcı",
    totalSessions: "Toplam Sohbet",
    totalMessages: "Toplam Mesaj",
    securityAlerts: "Güvenlik Uyarısı",
    kidsSecurityAlerts: "Kids Güvenlik",
    proUsers: "Pro Kullanıcılar",
    totalRevenue: "Toplam Gelir",
    supportTickets: "Destek Talepleri",
    privacyProtected: "Gizlilik korumalı - Detaylar görüntülenemez",
    privacyProtectedMessages: "Gizlilik korumalı - Mesajlar görüntülenemez",
    critical: "Kritik",
    high: "Yüksek",
    medium: "Orta",
    low: "Düşük",
    pending: "Beklemede",
    reviewed: "İncelendi",
    openTickets: "Açık Talepler",
    resolvedTickets: "Çözülen Talepler",
    userDetails: "Kullanıcı Detayları",
    statistics: "İstatistikler",
    live: "Canlı",
    analytics: "Analitik",
    activity: "Aktivite",
    security: "Güvenlik",
    kids: "Kids",
    payments: "Ödemeler",
    support: "Destek",
    faq: "Sık Sorulanlar",
    anomalies: "Anomaliler",
    admins: "Adminler",
    learning: "Öğrenme",
    memory: "Hafıza",
    dataRequests: "Veri İstekleri",
    authorization: "Yetkilendirme",
    
    // Admin tabs content
    overview: "Genel Bakış",
    recentActivity: "Son Aktivite",
    userGrowth: "Kullanıcı Artışı",
    messageVolume: "Mesaj Hacmi",
    activeUsers: "Aktif Kullanıcılar",
    registeredUsers: "Kayıtlı Kullanıcılar",
    guestUsers: "Misafir Kullanıcılar",
    kidsUsers: "Kids Kullanıcılar",
    activeToday: "Bugün Aktif",
    last7Days: "Son 7 Gün",
    last30Days: "Son 30 Gün",
    totalCount: "Toplam",
    status: "Durum",
    actions: "İşlemler",
    details: "Detaylar",
    view: "Görüntüle",
    edit: "Düzenle",
    delete: "Sil",
    approve: "Onayla",
    reject: "Reddet",
    export: "Dışa Aktar",
    filter: "Filtrele",
    sortBy: "Sırala",
    dateRange: "Tarih Aralığı",
    riskLevel: "Risk Seviyesi",
    category: "Kategori",
    timestamp: "Zaman",
    user: "Kullanıcı",
    message: "Mesaj",
    response: "Yanıt",
    session: "Oturum",
    noDataAvailable: "Veri bulunamadı",
    loadingData: "Veriler yükleniyor...",
    errorLoadingData: "Veri yüklenirken hata oluştu",
    subscription: "Abonelik",
    free: "Ücretsiz",
    pro: "PRO",
    admin: "Admin",
    assignToProgress: "İşleme Al",
    resolve: "Çöz",
    reopen: "Yeniden Aç",
    adminNote: "Admin Notu",
    addNote: "Not Ekle",
  },
  
  en: {
    // Common
    save: "Save",
    cancel: "Cancel",
    close: "Close",
    submit: "Submit",
    loading: "Loading...",
    search: "Search",
    
    // Auth
    login: "Login",
    register: "Register",
    email: "Email",
    password: "Password",
    name: "Full Name",
    forgotPassword: "Forgot Password",
    
    // Menu
    notifications: "Notifications",
    support: "Support",
    personalization: "Personalization",
    settings: "Settings",
    parentPanel: "Parent Panel",
    logout: "Logout",
    back: "Back",
    
    // Support
    supportCenter: "Support Center",
    newTicket: "New Ticket",
    myTickets: "My Tickets",
    category: "Category",
    subject: "Subject",
    message: "Your Message",
    sendTicket: "Send Support Ticket",
    noTickets: "You haven't created any support tickets yet",
    ticketCreated: "Create Your First Ticket",
    supportTeamResponse: "Our support team typically responds within 24 hours.",
    
    // Categories
    general: "General",
    technical: "Technical Issue",
    billing: "Billing/Subscription",
    feedback: "Feedback",
    
    // Status
    open: "Open",
    inProgress: "In Progress",
    closed: "Closed",
    resolved: "Resolved",
    
    // Notifications
    noNotifications: "No notifications yet",
    markAllRead: "Mark All as Read",
    supportResolved: "Your Support Ticket Has Been Resolved",
    
    // Personalization
    theme: "Theme",
    dark: "Dark",
    light: "Light",
    language: "Language",
    languageNote: "Language settings saved",
    
    // Placeholders
    enterEmail: "example@email.com",
    enterPassword: "********",
    enterSubject: "Subject of your support request",
    enterMessage: "Please describe your issue or feedback in detail...",
    
    // Parent Dashboard
    parentDashboard: "Parent Dashboard",
    myChildren: "My Children",
    addChild: "Add Child",
    linkExistingChild: "Link Existing Account",
    createNewChild: "Create New Account",
    overview: "Overview",
    riskHistory: "Risk History",
    chatHistory: "Chat History",
    notificationSettings: "Notification Settings",
    childName: "Child Name",
    childEmail: "Child Email",
    age: "Age",
    grade: "Grade",
    linkRequest: "Send Link Request",
    createAccount: "Create Account",
    noChildren: "No linked child accounts yet",
    selectChild: "Select a child",
    totalThreats: "Total Threats",
    criticalThreats: "Critical Threats",
    riskScore: "Risk Score",
    lastActivity: "Last Activity",
    noRiskHistory: "No risk history found",
    noChatHistory: "No chat history found",
    emailNotifications: "Email Notifications",
    phoneNotifications: "Phone Notifications",
    
    // Admin Dashboard
    adminDashboard: "Admin Dashboard",
    users: "Users",
    sessions: "Sessions",
    messages: "Messages",
    totalUsers: "Total Users",
    totalSessions: "Total Sessions",
    totalMessages: "Total Messages",
    securityAlerts: "Security Alerts",
    kidsSecurityAlerts: "Kids Security",
    proUsers: "Pro Users",
    totalRevenue: "Total Revenue",
    supportTickets: "Support Tickets",
    privacyProtected: "Privacy protected - Details cannot be viewed",
    privacyProtectedMessages: "Privacy protected - Messages cannot be viewed",
    critical: "Critical",
    high: "High",
    medium: "Medium",
    low: "Low",
    pending: "Pending",
    reviewed: "Reviewed",
    openTickets: "Open Tickets",
    resolvedTickets: "Resolved Tickets",
    userDetails: "User Details",
    statistics: "Statistics",
    live: "Live",
    analytics: "Analytics",
    activity: "Activity",
    security: "Security",
    kids: "Kids",
    payments: "Payments",
    support: "Support",
    faq: "FAQ",
    anomalies: "Anomalies",
    admins: "Admins",
    learning: "Learning",
    memory: "Memory",
    dataRequests: "Data Requests",
    authorization: "Authorization",
    
    // Admin tabs content
    overview: "Overview",
    recentActivity: "Recent Activity",
    userGrowth: "User Growth",
    messageVolume: "Message Volume",
    activeUsers: "Active Users",
    registeredUsers: "Registered Users",
    guestUsers: "Guest Users",
    kidsUsers: "Kids Users",
    activeToday: "Active Today",
    last7Days: "Last 7 Days",
    last30Days: "Last 30 Days",
    totalCount: "Total",
    status: "Status",
    actions: "Actions",
    details: "Details",
    view: "View",
    edit: "Edit",
    delete: "Delete",
    approve: "Approve",
    reject: "Reject",
    export: "Export",
    filter: "Filter",
    sortBy: "Sort By",
    dateRange: "Date Range",
    riskLevel: "Risk Level",
    category: "Category",
    timestamp: "Timestamp",
    user: "User",
    message: "Message",
    response: "Response",
    session: "Session",
    noDataAvailable: "No data available",
    loadingData: "Loading data...",
    errorLoadingData: "Error loading data",
    faq: "FAQ",
    anomalies: "Anomalies",
    admins: "Admins",
    learning: "Learning",
    memory: "Memory",
    dataRequests: "Data Requests",
    subscription: "Subscription",
    free: "Free",
    pro: "PRO",
    admin: "Admin",
    assignToProgress: "Assign to Progress",
    resolve: "Resolve",
    reopen: "Reopen",
    adminNote: "Admin Note",
    addNote: "Add Note",
  },
  
  de: {
    // Common
    save: "Speichern",
    cancel: "Abbrechen",
    close: "Schließen",
    submit: "Senden",
    loading: "Lädt...",
    search: "Suchen",
    
    // Auth
    login: "Anmelden",
    register: "Registrieren",
    email: "E-Mail",
    password: "Passwort",
    name: "Vollständiger Name",
    forgotPassword: "Passwort vergessen",
    
    // Menu
    notifications: "Benachrichtigungen",
    support: "Support",
    personalization: "Personalisierung",
    settings: "Einstellungen",
    parentPanel: "Eltern-Panel",
    logout: "Abmelden",
    back: "Zurück",
    
    // Support
    supportCenter: "Support-Center",
    newTicket: "Neues Ticket",
    myTickets: "Meine Tickets",
    category: "Kategorie",
    subject: "Betreff",
    message: "Ihre Nachricht",
    sendTicket: "Support-Ticket senden",
    noTickets: "Sie haben noch keine Support-Tickets erstellt",
    ticketCreated: "Erstellen Sie Ihr erstes Ticket",
    supportTeamResponse: "Unser Support-Team antwortet normalerweise innerhalb von 24 Stunden.",
    
    // Categories
    general: "Allgemein",
    technical: "Technisches Problem",
    billing: "Abrechnung/Abonnement",
    feedback: "Feedback",
    
    // Status
    open: "Offen",
    inProgress: "In Bearbeitung",
    closed: "Geschlossen",
    resolved: "Gelöst",
    
    // Notifications
    noNotifications: "Noch keine Benachrichtigungen",
    markAllRead: "Alle als gelesen markieren",
    supportResolved: "Ihr Support-Ticket wurde gelöst",
    
    // Personalization
    theme: "Design",
    dark: "Dunkel",
    light: "Hell",
    language: "Sprache",
    languageNote: "Spracheinstellungen gespeichert",
    
    // Placeholders
    enterEmail: "beispiel@email.com",
    enterPassword: "********",
    enterSubject: "Betreff Ihrer Support-Anfrage",
    enterMessage: "Bitte beschreiben Sie Ihr Problem oder Feedback detailliert...",
    
    // Parent Dashboard
    parentDashboard: "Eltern-Dashboard",
    myChildren: "Meine Kinder",
    addChild: "Kind hinzufügen",
    linkExistingChild: "Bestehendes Konto verknüpfen",
    createNewChild: "Neues Konto erstellen",
    overview: "Übersicht",
    riskHistory: "Risikoverlauf",
    chatHistory: "Chat-Verlauf",
    notificationSettings: "Benachrichtigungseinstellungen",
    childName: "Name des Kindes",
    childEmail: "E-Mail des Kindes",
    age: "Alter",
    grade: "Klasse",
    linkRequest: "Verknüpfungsanfrage senden",
    createAccount: "Konto erstellen",
    noChildren: "Noch keine verknüpften Kinderkonten",
    selectChild: "Kind auswählen",
    totalThreats: "Gesamtbedrohungen",
    criticalThreats: "Kritische Bedrohungen",
    riskScore: "Risikobewertung",
    lastActivity: "Letzte Aktivität",
    noRiskHistory: "Kein Risikoverlauf gefunden",
    noChatHistory: "Kein Chat-Verlauf gefunden",
    emailNotifications: "E-Mail-Benachrichtigungen",
    phoneNotifications: "Telefonbenachrichtigungen",
    
    // Admin Dashboard
    adminDashboard: "Admin-Dashboard",
    users: "Benutzer",
    sessions: "Sitzungen",
    messages: "Nachrichten",
    totalUsers: "Gesamtbenutzer",
    activeToday: "Heute aktiv",
    proUsers: "PRO-Benutzer",
    kidsUsers: "Kinder-Benutzer",
    supportTickets: "Support-Tickets",
    openTickets: "Offene Tickets",
    resolvedTickets: "Gelöste Tickets",
    userDetails: "Benutzerdetails",
    subscription: "Abonnement",
    free: "Kostenlos",
    pro: "PRO",
    admin: "Admin",
    assignToProgress: "In Bearbeitung nehmen",
    resolve: "Lösen",
    reopen: "Wieder öffnen",
    adminNote: "Admin-Notiz",
    addNote: "Notiz hinzufügen",
  },
  
  fr: {
    // Common
    save: "Enregistrer",
    cancel: "Annuler",
    close: "Fermer",
    submit: "Soumettre",
    loading: "Chargement...",
    search: "Rechercher",
    
    // Auth
    login: "Se connecter",
    register: "S'inscrire",
    email: "E-mail",
    password: "Mot de passe",
    name: "Nom complet",
    forgotPassword: "Mot de passe oublié",
    
    // Menu
    notifications: "Notifications",
    support: "Support",
    personalization: "Personnalisation",
    settings: "Paramètres",
    parentPanel: "Panneau parent",
    logout: "Se déconnecter",
    back: "Retour",
    
    // Support
    supportCenter: "Centre de support",
    newTicket: "Nouveau ticket",
    myTickets: "Mes tickets",
    category: "Catégorie",
    subject: "Sujet",
    message: "Votre message",
    sendTicket: "Envoyer un ticket de support",
    noTickets: "Vous n'avez pas encore créé de tickets de support",
    ticketCreated: "Créez votre premier ticket",
    supportTeamResponse: "Notre équipe de support répond généralement dans les 24 heures.",
    
    // Categories
    general: "Général",
    technical: "Problème technique",
    billing: "Facturation/Abonnement",
    feedback: "Commentaires",
    
    // Status
    open: "Ouvert",
    inProgress: "En cours",
    closed: "Fermé",
    resolved: "Résolu",
    
    // Notifications
    noNotifications: "Pas encore de notifications",
    markAllRead: "Tout marquer comme lu",
    supportResolved: "Votre ticket de support a été résolu",
    
    // Personalization
    theme: "Thème",
    dark: "Sombre",
    light: "Clair",
    language: "Langue",
    languageNote: "Paramètres de langue enregistrés",
    
    // Placeholders
    enterEmail: "exemple@email.com",
    enterPassword: "********",
    enterSubject: "Sujet de votre demande de support",
    enterMessage: "Veuillez décrire votre problème ou vos commentaires en détail...",
    
    // Parent Dashboard
    parentDashboard: "Tableau de bord parent",
    myChildren: "Mes enfants",
    addChild: "Ajouter un enfant",
    linkExistingChild: "Lier un compte existant",
    createNewChild: "Créer un nouveau compte",
    overview: "Aperçu",
    riskHistory: "Historique des risques",
    chatHistory: "Historique des discussions",
    notificationSettings: "Paramètres de notification",
    childName: "Nom de l'enfant",
    childEmail: "E-mail de l'enfant",
    age: "Âge",
    grade: "Classe",
    linkRequest: "Envoyer une demande de liaison",
    createAccount: "Créer un compte",
    noChildren: "Aucun compte enfant lié pour le moment",
    selectChild: "Sélectionner un enfant",
    totalThreats: "Menaces totales",
    criticalThreats: "Menaces critiques",
    riskScore: "Score de risque",
    lastActivity: "Dernière activité",
    noRiskHistory: "Aucun historique de risque trouvé",
    noChatHistory: "Aucun historique de discussion trouvé",
    emailNotifications: "Notifications par e-mail",
    phoneNotifications: "Notifications téléphoniques",
    
    // Admin Dashboard
    adminDashboard: "Tableau de bord admin",
    users: "Utilisateurs",
    sessions: "Sessions",
    messages: "Messages",
    totalUsers: "Total des utilisateurs",
    activeToday: "Actif aujourd'hui",
    proUsers: "Utilisateurs PRO",
    kidsUsers: "Utilisateurs enfants",
    supportTickets: "Tickets de support",
    openTickets: "Tickets ouverts",
    resolvedTickets: "Tickets résolus",
    userDetails: "Détails de l'utilisateur",
    subscription: "Abonnement",
    free: "Gratuit",
    pro: "PRO",
    admin: "Admin",
    assignToProgress: "Assigner en cours",
    resolve: "Résoudre",
    reopen: "Rouvrir",
    adminNote: "Note admin",
    addNote: "Ajouter une note",
  },
  
  es: {
    // Common
    save: "Guardar",
    cancel: "Cancelar",
    close: "Cerrar",
    submit: "Enviar",
    loading: "Cargando...",
    search: "Buscar",
    
    // Auth
    login: "Iniciar sesión",
    register: "Registrarse",
    email: "Correo electrónico",
    password: "Contraseña",
    name: "Nombre completo",
    forgotPassword: "Olvidé mi contraseña",
    
    // Menu
    notifications: "Notificaciones",
    support: "Soporte",
    personalization: "Personalización",
    settings: "Configuración",
    parentPanel: "Panel de padres",
    logout: "Cerrar sesión",
    back: "Volver",
    
    // Support
    supportCenter: "Centro de soporte",
    newTicket: "Nuevo ticket",
    myTickets: "Mis tickets",
    category: "Categoría",
    subject: "Asunto",
    message: "Tu mensaje",
    sendTicket: "Enviar ticket de soporte",
    noTickets: "Aún no has creado ningún ticket de soporte",
    ticketCreated: "Crea tu primer ticket",
    supportTeamResponse: "Nuestro equipo de soporte generalmente responde en 24 horas.",
    
    // Categories
    general: "General",
    technical: "Problema técnico",
    billing: "Facturación/Suscripción",
    feedback: "Comentarios",
    
    // Status
    open: "Abierto",
    inProgress: "En progreso",
    closed: "Cerrado",
    resolved: "Resuelto",
    
    // Notifications
    noNotifications: "Aún no hay notificaciones",
    markAllRead: "Marcar todo como leído",
    supportResolved: "Tu ticket de soporte ha sido resuelto",
    
    // Personalization
    theme: "Tema",
    dark: "Oscuro",
    light: "Claro",
    language: "Idioma",
    languageNote: "Configuración de idioma guardada",
    
    // Placeholders
    enterEmail: "ejemplo@email.com",
    enterPassword: "********",
    enterSubject: "Asunto de tu solicitud de soporte",
    enterMessage: "Por favor describe tu problema o comentarios en detalle...",
    
    // Parent Dashboard
    parentDashboard: "Panel de padres",
    myChildren: "Mis hijos",
    addChild: "Agregar hijo",
    linkExistingChild: "Vincular cuenta existente",
    createNewChild: "Crear nueva cuenta",
    overview: "Resumen",
    riskHistory: "Historial de riesgos",
    chatHistory: "Historial de chat",
    notificationSettings: "Configuración de notificaciones",
    childName: "Nombre del hijo",
    childEmail: "Correo del hijo",
    age: "Edad",
    grade: "Grado",
    linkRequest: "Enviar solicitud de vinculación",
    createAccount: "Crear cuenta",
    noChildren: "Aún no hay cuentas de hijos vinculadas",
    selectChild: "Seleccionar un hijo",
    totalThreats: "Amenazas totales",
    criticalThreats: "Amenazas críticas",
    riskScore: "Puntuación de riesgo",
    lastActivity: "Última actividad",
    noRiskHistory: "No se encontró historial de riesgos",
    noChatHistory: "No se encontró historial de chat",
    emailNotifications: "Notificaciones por correo",
    phoneNotifications: "Notificaciones telefónicas",
    
    // Admin Dashboard
    adminDashboard: "Panel de administración",
    users: "Usuarios",
    sessions: "Sesiones",
    messages: "Mensajes",
    totalUsers: "Total de usuarios",
    activeToday: "Activos hoy",
    proUsers: "Usuarios PRO",
    kidsUsers: "Usuarios niños",
    supportTickets: "Tickets de soporte",
    openTickets: "Tickets abiertos",
    resolvedTickets: "Tickets resueltos",
    userDetails: "Detalles del usuario",
    subscription: "Suscripción",
    free: "Gratis",
    pro: "PRO",
    admin: "Admin",
    assignToProgress: "Asignar en progreso",
    resolve: "Resolver",
    reopen: "Reabrir",
    adminNote: "Nota del admin",
    addNote: "Agregar nota",
  },
};

export const getTranslation = (language, key) => {
  return translations[language]?.[key] || translations['tr'][key] || key;
};
